export type NetworkTypeStyle = {
	label: string;
	bgColor: string;
	textColor: string;
};

export const networkTypeConfig: Record<Dryp.NetworkType, NetworkTypeStyle> = {
	unknown: {
		label: "Unknown",
		bgColor: "#9CA3AF", // gray-400
		textColor: "#000000",
	},
	waste: {
		label: "Waste",
		bgColor: "#374151", // gray-700
		textColor: "#FFFFFF",
	},
	rain: {
		label: "Rain",
		bgColor: "#3B82F6", // blue-500
		textColor: "#FFFFFF",
	},
	combined: {
		label: "Combined",
		bgColor: "#10B981", // green-500
		textColor: "#FFFFFF",
	},
};
